let ServiceDetailType = /*#__PURE__*/function (ServiceDetailType) {
  ServiceDetailType["INFO"] = "info";
  ServiceDetailType["DETAILS"] = "details";
  return ServiceDetailType;
}({});

export { ServiceDetailType };
//# sourceMappingURL=ServiceDetails.js.map
